'use client';

import { lazy, Suspense, type ComponentProps } from 'react';

import type { MapComponent as MapImpl } from './map';

/**
 * mapbox-gl ships ~40KB of CSS and hundreds of KB of JS. Loading it as a
 * `React.lazy` chunk keeps mapbox out of every layout that transitively
 * imports the design-system barrel.
 */
const LazyMap = lazy(() =>
  import('./map').then((m) => ({ default: m.MapComponent })),
);

const MapView = (props: ComponentProps<typeof MapImpl>) => (
  <Suspense fallback={null}>
    <LazyMap {...props} />
  </Suspense>
);

export { MapView as Map };
